import Resource from '@/api/resources/Resource'

class PersonnelResponsibilityConfigurationServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/personnelResponsibilities`, filterModel, { params })
        return response.data
    }
    async getPersonnelResponsibilitiesByPersonnelId(personnelId) {
        const response = await this.axios.get(`/configuration/personnels/${personnelId}/personnelResponsibilities`)
        return response.data
    }
    async createPersonnelResponsibility(personnelResponsibilityCreateRequest) {
        const response = await this.axios.post(`/configuration/personnelResponsibilities`, personnelResponsibilityCreateRequest)
        return response.data
    }
    async deletePersonnelResponsibility(personnelResponsibilityId) {
        const response = await this.axios.delete(`/configuration/personnelResponsibilities/${personnelResponsibilityId}`)
        return response.data
    }
}

export default new PersonnelResponsibilityConfigurationServices()
